import { render, staticRenderFns } from "./patentList.vue?vue&type=template&id=79bd0707&scoped=true&"
import script from "./patentList.vue?vue&type=script&lang=js&"
export * from "./patentList.vue?vue&type=script&lang=js&"
import style0 from "./patentList.vue?vue&type=style&index=0&id=79bd0707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd0707",
  null
  
)

export default component.exports